<script setup lang="ts">
  import { MyAccountRoute } from "@/constants/routes/myAccount"
  import { computed } from "vue"
  import { useRoute, useRouter } from "vue-router"
  import MaintenanceBanner from "@/components/shared/maintenance-banner/MaintenanceBanner.vue"
  import { Sidebar } from "@/components/sidebar"
  import { PageHeader } from "@/components/ui/page-header"

  const route = useRoute()
  const router = useRouter()
  const title = computed(() => (route.meta?.title as string) || "")
  const hideBackButton = computed(() => !!route.meta?.hideBackButton)
  const backButtonPath = computed(() => route.meta?.backButtonPath as string)

  const handleBackClick = () => {
    if (backButtonPath.value) {
      router.push(backButtonPath.value)
    } else if (window.history.state?.back) {
      router.back()
    } else {
      router.push(MyAccountRoute.home)
    }
  }
</script>

<template>
  <main
    class="container flex flex-col p-6 pt-4 sm:px-10 md:flex-row md:flex-nowrap md:p-6 md:px-14"
  >
    <PageHeader
      v-if="title"
      :title="title"
      :has-back-button="!hideBackButton"
      class="mb-4 mt-2 md:my-6 md:hidden"
      @back="handleBackClick"
    />
    <Sidebar />
    <div class="min-w-0 flex-1">
      <PageHeader
        v-if="title"
        id="main-content"
        tabindex="-1"
        :title="title"
        :has-back-button="!hideBackButton"
        class="hidden sm:mb-6 md:mt-5 md:flex"
        @back="handleBackClick"
      />
      <div>
        <MaintenanceBanner class="mb-4 sm:mb-6" />
        <slot />
      </div>
    </div>
  </main>
</template>
